<div class="w-full h-full p-4">

  <div class="right-5 top-5 absolute flex gap-2">
    <!-- help -->
    <ew-button-help [url]="urlHelp" *ngIf="urlHelp"></ew-button-help>

    <!-- Close -->
    <button
      mat-icon-button
      name=""
      aria-label="Close"
      (click)="dialogRef.close()">
      <mat-icon class="icon-size-17 fa-regular fa-xmark"></mat-icon>
    </button>
  </div>

  <ng-content></ng-content>
</div>
